'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagLyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 8.88109e-06C9.33333 -8.36891e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 13.3333H28V6.66667H0V13.3333Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#34B857"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.66667H28V0L0 8.88109e-06V6.66667Z",
          fill: "#F41F34"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14 12C14.4113 12 14.7936 11.8759 15.1114 11.663C15.0746 11.6654 15.0374 11.6667 15 11.6667C14.0795 11.6667 13.3333 10.9205 13.3333 10C13.3333 9.07952 14.0795 8.33333 15 8.33333C15.0374 8.33333 15.0746 8.33457 15.1114 8.337C14.7936 8.12414 14.4113 8 14 8C12.8954 8 12 8.89543 12 10C12 11.1046 12.8954 12 14 12Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16 10C16 10.3682 15.7015 10.6667 15.3333 10.6667C14.9651 10.6667 14.6667 10.3682 14.6667 10C14.6667 9.63181 14.9651 9.33333 15.3333 9.33333C15.7015 9.33333 16 9.63181 16 10Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagLyAsset = forwardRef(FlagLyAsset);

export { VpFlagLyAsset as default };
